import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {updateCheckInReminder} from '/redux/action/candidate.action';
import {
  hasReminderDetails,
  reminderDetailsById,
} from '/redux/selector/candidate.selector';

import CheckedInReminder from './CheckedInReminder';

export default connect(
  createStructuredSelector({
    reminderDetails: reminderDetailsById,
    hasReminderDetails,
  }),
  dispatch => ({
    updateCheckInReminder: ({reminderData, candidateId, reportData}: any) =>
      dispatch<any>(
        updateCheckInReminder({
          reminderData,
          candidateId,
          allReportData: reportData,
        }),
      ),
  }),
  (stateProps, dispatchProps, ownProps) => {
    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      updateCheckInReminder: ({reminderData, candidateId}: any) => {
        const {allReportData} = stateProps;
        return dispatchProps.updateCheckInReminder({
          reminderData,
          candidateId,
          reportData: allReportData,
        });
      },
    };
  },
)(CheckedInReminder);
